import React from 'react';
import { Clock, LogOut, RefreshCw } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useAuth } from '@/contexts/AuthContext';

const SessionTimeoutDialog = () => {
  const { 
    showSessionWarning, 
    sessionTimeRemaining, 
    confirmSessionRefresh, 
    declineSessionRefresh 
  } = useAuth();

  if (!showSessionWarning) return null;

  return (
    <AlertDialog open={showSessionWarning} onOpenChange={() => {}}>
      <AlertDialogContent className="max-w-md" data-testid="session-timeout-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-amber-600">
            <Clock className="w-5 h-5" />
            Sessão a Expirar
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-4">
              <p>
                A sua sessão irá expirar em{' '}
                <span className="font-bold text-amber-600 text-lg">
                  {Math.floor(sessionTimeRemaining / 60)}:{String(sessionTimeRemaining % 60).padStart(2, '0')}
                </span>{' '}
                (min:seg) por motivos de segurança.
              </p>
              
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                <p className="text-sm text-amber-800">
                  <strong>Deseja continuar a trabalhar?</strong>
                </p>
                <p className="text-sm text-amber-700 mt-1">
                  Clique em "Continuar Sessão" para renovar a sua sessão, 
                  ou "Terminar Sessão" para sair da aplicação.
                </p>
              </div>

              {/* Progress bar */}
              <div className="w-full bg-slate-200 rounded-full h-2 overflow-hidden">
                <div 
                  className="h-full bg-amber-500 transition-all duration-1000 ease-linear"
                  style={{ width: `${(sessionTimeRemaining / 120) * 100}%` }}
                />
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2 sm:gap-0">
          <AlertDialogCancel 
            onClick={declineSessionRefresh}
            className="bg-slate-100 hover:bg-slate-200 text-slate-700"
            data-testid="decline-session-btn"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Terminar Sessão
          </AlertDialogCancel>
          <AlertDialogAction 
            onClick={confirmSessionRefresh}
            className="bg-green-600 hover:bg-green-700 text-white"
            data-testid="confirm-session-btn"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Continuar Sessão
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default SessionTimeoutDialog;
